<template>
  <div class="invoice-list">
    <div class="page-title">开具发票</div>
    <page-tab
      :tabs="tabs"
      :nowTab="nowTab"
      :paramsLabel="'index'"
    ></page-tab>
    <page-search
      :layout="layout"
      @search="search"
      @exportTable="exportTable"
    ></page-search>
    <pageTable
      :loading="loading"
      :col="col"
      :data="data"
      :total="total"
      :pageSize="pageSize"
      :pageIndex="pageIndex"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTab from '@/components/pageCom/pageTab.vue'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import invoiceListDataMixin from './components/invoiceListDataMixin'
import {
  invoiceVipList, invoiceUkeyList, invoiceFeeList,
  getNeedAddCount
} from '@/api/invoice'
import { downFile } from '@/utils/file'
export default {
  name: 'invoice',
  components: {
    pageTab,
    pageSearch,
    pageTable
  },
  mixins: [invoiceListDataMixin],
  data() {
    return {
      loading: false,
      data: [],
      total: 0,
      pageSize: 30,
      pageIndex: 1,
      searchParams: {}
    }
  },
  methods: {
    // 获取表格
    getData() {
      this.getNeedCount()
      this.loading = true

      if (this.nowTab === 'vipInvoice') {
        invoiceVipList({
          cust_no: this.searchParams.code || '',
          cust_name: this.searchParams.name || '',
          order_start_time: (this.searchParams && this.searchParams.date && this.searchParams.date[0]) || '',
          order_end_time: (this.searchParams && this.searchParams.date && this.searchParams.date[1]) || '',
          per_page: this.pageSize,
          page: this.pageIndex
        }).then(res => {
          this.dealWithRes(res)
        })
      } else if (this.nowTab === 'ukeyInvoice') {
        invoiceUkeyList({
          cust_no: this.searchParams.code || '',
          cust_name: this.searchParams.name || '',
          create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
          create_time_end: this.searchParams.date ? this.searchParams.date[1] : '',
          per_page: this.pageSize,
          page: this.pageIndex
        }).then(res => {
          this.dealWithRes(res)
        })
      } else {
        invoiceFeeList({
          payer: this.searchParams.payer || '',
          receiver: this.searchParams.payee || '',
          create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
          create_time_end: this.searchParams.date ? this.searchParams.date[1] : '',
          per_page: this.pageSize,
          page: this.pageIndex
        }).then(res => {
          this.dealWithRes(res)
        })
      }
    },
    dealWithRes(res) {
      this.loading = false
      const { code, result } = res
      if (code === 0) {
        this.data = result.data
        this.total = result.total || result.count
      } else {
        this.data = []
        this.total = 0
        this.$Message.info('获取数据失败')
      }
    },
    // 获取tab上数目
    getNeedCount() {
      let req = {}
      if (this.nowTab === 'vipInvoice') {
        // ----------还在改
        req = {
          tab_type: '3',
          cust_no: this.searchParams.code || '',
          cust_name: this.searchParams.name || '',
          order_start_time: (this.searchParams && this.searchParams.date && this.searchParams.date[0]) || '',
          order_end_time: (this.searchParams && this.searchParams.date && this.searchParams.date[1]) || ''
        }
      } else if (this.nowTab === 'ukeyInvoice') {
        req = {
          tab_type: '1',
          cust_no: this.searchParams.code || '',
          cust_name: this.searchParams.name || '',
          create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
          create_time_end: this.searchParams.date ? this.searchParams.date[1] : ''
        }
      } else {
        req = {
          tab_type: '2',
          payer: this.searchParams.payer || '',
          receiver: this.searchParams.payee || '',
          create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
          create_time_end: this.searchParams.date ? this.searchParams.date[1] : ''
        }
      }
      getNeedAddCount(req).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.tabs[0].num = '待开' + (result.hy_order || 0)
          this.tabs[1].num = '待开' + (result.ukey || 0)
          this.tabs[2].num = '待开' + (result.service || 0)
        } else {
          this.$Message.info('获取待开数据失败！')
        }
      })
    },
    // 搜索
    search(query) {
      // 返回的字段 code name date
      this.searchParams = query

      this.pageIndex = 1
      this.pageSize = 30

      this.getData()
    },
    pageChange(page) {
      this.pageIndex = page
      this.getData()
    },
    pageSizeChange(size) {
      this.pageIndex = 1
      this.pageSize = size
      this.getData()
    },
    // 导出
    exportTable(query) {
      const url = process.env.VUE_APP_BASE_API + '/invoice/export_excel'
      let req = {}

      if (this.nowTab === 'vipInvoice') {
        req = {
          table_type: '3',
          cust_no: this.searchParams.code || '',
          cust_name: this.searchParams.name || '',
          order_start_time: (this.searchParams && this.searchParams.date && this.searchParams.date[0]) || '',
          order_end_time: (this.searchParams && this.searchParams.date && this.searchParams.date[1]) || ''
        }
      } else if (this.nowTab === 'ukeyInvoice') {
        req = {
          table_type: '1',
          cust_no: this.searchParams.code || '',
          cust_name: this.searchParams.name || '',
          create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
          create_time_end: this.searchParams.date ? this.searchParams.date[1] : ''
        }
      } else {
        req = {
          table_type: '2',
          payer: this.searchParams.payer || '',
          receiver: this.searchParams.payee || '',
          create_time_start: this.searchParams.date ? this.searchParams.date[0] : '',
          create_time_end: this.searchParams.date ? this.searchParams.date[1] : ''
        }
      }
      downFile(url, req)
    }
  }
}
</script>
